
import { defineComponent, ref } from 'vue';
import { Button, Icon, Popup } from 'vant';
import { useRouter } from 'vue-router';

export default defineComponent({
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    Popup,
  },
  setup() {
    const router = useRouter();
    const isShow = ref(false);
    const onShow = () => {
      isShow.value = !isShow.value;
    };
    const onJump = (url: string) => {
      isShow.value = false;
      router.push({ path: url });
    };
    return {
      isShow,
      onShow,
      onJump,
    };
  },
});
